import React from 'react'

function Verification() {
  return <div>Verification</div>
}

export default Verification
